const recurseOnItem = (item, path) => {
  var deepest = null;

  //if this item has child items, we search there.
  if (item.items && item.items.length > 0) {
    for (var i = 0; i < item.items.length; i++) {
      var childItem = item.items[i];
      deepest = recurseOnItem(childItem, path);
      if (deepest) {
        return deepest;
      }
    }
  }

  // if (item.href && item.href.indexOf(path) >= 0) {

  if (item.href && path) {

    //split by /.  The filter excludes the first "" because that will be falsy and therefore filtered out
    const hrefParts = item.href.split("/").filter((p) => p).map(p => {
      return p.split("?")[0];//get rid of query string for our comparison purposes
    });
    const pathParts = path.split("/").filter((p) => p).map(p => {
      return p.split("?")[0];//get rid of query string for our comparison purposes
    });

    if (hrefParts.length === 0 && pathParts.length === 0) {
      return item;
    } else if (hrefParts.length > 0) {
      //path parts could be the longer and will never be shorter
      //matchCheck is an array of booleans indicating that each href part is or is not a match to the same part in the path parts list
      const matchCheck = hrefParts.map((part, index) => {
        const pathPart = pathParts[index];
        return pathPart === part;
      });

      const allTrue = matchCheck.reduce((prev, current) => {
        return prev && current;
      }, true);

      if (allTrue) {
        return item;
      }
    }

    return null;
  }
};

export const identifyActiveHref = (items) => {

  //start is an array of items, and in order for us to treat this recursively, we need it to look like a single root item
  const path = window.location.path || window.location.pathname;
  const copyItems = [...items];
  copyItems.shift(); //that chops the first one off.  Our first one is "home" recurse on item was built
  //expecting us not to have that guy, which would give us a match that turns out to be a false positive.
  const startObj = { items: copyItems };
  let deepest = recurseOnItem(startObj, path);
  if (!deepest && items?.length > 0) {
    //if we didn't get a match we may well be right on our home
    //so we execute a check just for that.
    const justHome = [items[0]];
    deepest = recurseOnItem({items:justHome},path);
  }
  return deepest ? deepest.href : "/";
};
